export const CONSTANTS = {
  NOPRIME: 'NOPRIME',
  VIPPRIME: 'VIPPRIME',
  BASICPRIME: 'BASICPRIME',
  SMARTPRIME: 'SMARTPRIME',
  VIP: 'VIP',
  BASIC: 'BASIC',
  SMART: 'SMART',
} as const;
